// src/components/FAQSection.js
import React from 'react';
import './FAQSection.css';
import FAQItem from './FAQItem';

const FAQSection = () => {
  return (
    <section className="faq-section container">
      <h2 className="section-title">FAQs</h2>
      <div className="faq-list">
        <FAQItem question="How do I book an appointment?">
          <ul><p>
            You can book an appointment in seconds:<br />

            1.⁠ ⁠Simply click the “Book Now” button and enter your details. Our team will call you within 10 minutes to confirm. <br />

            2.⁠ ⁠Or, reach out to us directly via Call or WhatsApp at 9902356133. <br />

            3.⁠ ⁠You can also book through the Dr. Doodley App — available for download now. <br />

          </p>
          </ul>
        </FAQItem>
        <FAQItem question="What services do you offer at home?">
          <p>We treat common issues like vomiting, wounds, fever, itching, skin issues & allergies , yearly vaccination, limping, deworming & ticks, not eating food, hairfall and more. In case of critical care, it can be treated at our hospital. </p>
        </FAQItem>
        <FAQItem question="Do you have a Hospital too?">
          <p>Yes! We have 24/7 Multi-Speciality Pet hospitals in Jayanagar and in Yelahankha. Hospitals are equipped with X-ray, Ultrasound, Surgery & in-patient facilities. Visit us for vaccinations, advanced care, and diagnostics</p>
        </FAQItem>
        <FAQItem question="Which pets do you treat?">
          <p>We treat dogs, cats, Puppies and Kittens of all ages and breeds.</p>
        </FAQItem><FAQItem question="What are your home-visit hours?">
          <p>We’re available for home visits from 9AM-11PM all 7 days a week, including evenings and weekends.<br />
              In case of emergencies, we have 24/7 hospitals in Jayanagar and Yelahankha</p>
        </FAQItem><FAQItem question="Are your vets qualified?">
          <p>Absolutely— All our vets are certified, experienced, and trained in dogs & cats treatment.</p>
        </FAQItem>
      </div>
    </section>
  );
};

export default FAQSection;